import { render, staticRenderFns } from "./ChatSettings.vue?vue&type=template&id=3e15e3e6&scoped=true&"
import script from "./ChatSettings.vue?vue&type=script&lang=js&"
export * from "./ChatSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettings.vue?vue&type=style&index=0&id=3e15e3e6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e15e3e6",
  null
  
)

export default component.exports